export default __webpack_public_path__ + "static/media/psc-digi-skills.cc3b7ba7.jpg";